// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3abDk","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3JYgt"};